<template>
  <div>
    <div class="messageContainer">
      <span class="text-zt-md text-zt-primary-200">{{ message }}</span>
    </div>
    <div class="flex justify-around">
      <div>
        <button type="button" class="btn previewImage" @click="$swal.clickConfirm()">
          {{ $t('message.FileUploadComponent.previewBtn') }}
        </button>
      </div>
      <div v-if="!isDni">
        <button type="button" class="btn buttonPrimaryProperties" @click="addPage()">
          {{ $t('message.FileUploadComponent.addSheet') }}
        </button>
      </div>
      <div>
        <button type="button" class="btn buttonPrimaryProperties" @click="sendToRrhh()">
          {{ $t('message.FileUploadComponent.sendRRHH') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CustomSwalFooter',
  props: ['sendDocs', 'isDni', 'message', 'newPage'],
  methods: {
    sendToRrhh() {
      this.sendDocs()
      this.$swal.clickConfirm()
    },
    addPage() {
      this.newPage()
      this.$swal.clickConfirm()
    }
  }
}
</script>
<style>
.messageContainer {
  padding-bottom: 16px;
}

.previewImage {
  color: black;
  background-color: #c3c3c3;
  font-weight: 500;
}
</style>
